<app-exam-header [imageClass]="'home'"></app-exam-header>
<app-exam></app-exam>
<app-exam-footer></app-exam-footer>